function monitorCloseButton() {
  const iframe = document.getElementById('jsd-widget');

  if (iframe && iframe.contentWindow && iframe.contentWindow.document) {
    const iframeDocument = iframe.contentWindow.document;
    const closeButton = iframeDocument.querySelector(
      "button[data-testid='close']",
    );
    const helpButton = iframeDocument.querySelector('#help-button');
    const saveButton = iframeDocument.querySelector('#submit-button');

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        setTimeout(monitorCloseButton, 500);
      });
    } else {
      setTimeout(monitorCloseButton, 1000); // Retry if the button is not found
    }
    if (saveButton) {
      saveButton.addEventListener('click', () => {
        setTimeout(monitorCloseButton, 500);
      });
    }
    if (helpButton) {
      helpButton.style.display = 'none'; // Hide the help button
    } else {
      setTimeout(monitorCloseButton, 1000); // Keep checking if not yet found
    }
  } else {
    setTimeout(monitorCloseButton, 1000); // Keep checking for iframe
  }
}

// Start checking for the close button
monitorCloseButton();
